<template>
  <div
      style="width: 100%;background-color: #320e41;padding: 0 30px;z-index: 10;position:relative;display: flex;justify-content: center;">
    <div style="width:1360px;display: flex;align-items: center;justify-content: space-between;">
      <div style="display: inline-block;width: 1000px">
        <div @click="goto('/home')" style="display: inline-block;font-size: 20px;font-weight: bold;color: white;margin: 0 10px;cursor:pointer;">
          <img src="../../assets/onlyLogo.png" width="20"/>
          Brainview
        </div>
        <a-menu v-model:selectedKeys="current" mode="horizontal" theme="dark" style="display: inline-block;width: 50%">
          <a-menu-item key="mail" @click="goto('/home')">
            {{ $t("home") }}
          </a-menu-item>
          <a-sub-menu key="standard" :title="$t('standardBrain')">
            <a-menu-item key="surface" @click="goto('/standard/surface')">
              {{ $t("motorFunctionMapping") }}
            </a-menu-item>
            <a-menu-item key="language" @click="goto('/standard/language')">
              {{ $t("languageFunctionMapping") }}
            </a-menu-item>
            <a-menu-item key="fibre" @click="goto('/standard/fibre')">
              {{ $t("fibreBundleMapping") }}
            </a-menu-item>
            <a-menu-item key="statistic" @click="goto('/statistic')">
              {{ $t("dataAndStatistics") }}
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="personalBrain" :title="$t('personalBrain')">
            <a-menu-item key="electrical" @click="goto('/personal/electrical')">
              {{ $t("electricalPosition") }}
            </a-menu-item>
            <a-menu-item key="personalFibre" @click="goto('/personal/fibre')">
              {{ $t("fibreTrack") }}
            </a-menu-item>
          </a-sub-menu>
          <a-menu-item key="visit" @click="goto('/visit')">
            {{ $t("visitStatistics") }}
          </a-menu-item>
<!--          <a-menu-item key="contact" @click="goto('/contact')">-->
<!--            {{ $t("contactUs") }}-->
<!--          </a-menu-item>-->
        </a-menu>
      </div>
      <div style="line-height: 46px;z-index: 99;color: white">
        <!--      <a-button v-if="locale === 'zh'" @click="changeLang('en')">English</a-button>-->
        <!--      <a-button v-else @click="changeLang('zh')">中文</a-button>-->
        <a @click="changeLang('zh')">中文</a>
        <a-divider type="vertical" style="height: 16px; background-color: white"/>
        <a @click="changeLang('en')">English</a>
      </div>
    </div>
  </div>
  <div style="display: flex;justify-content: center;width: 100%">
    <div style="width: 1360px;display: inline-block">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "VNav",
  data() {
    return {
      locale: localStorage.getItem('local') || 'zh',
    }
  },
  methods: {
    changeLang(val) {
      localStorage.setItem("local", val);
      window.location.reload();
    },
    goto(val) {
      this.$router.push(val)
    },
  }
}
</script>

<style scoped>
a {
  color: white
}
</style>